import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { useSession } from '@/lib/auth/session'

/** OAuth and email-confirmation return. Supabase parses the URL fragment itself. */
export function AuthCallbackPage() {
  const { status } = useSession()
  const navigate = useNavigate()

  useEffect(() => {
    if (status === 'authenticated') void navigate('/', { replace: true })
    if (status === 'anonymous') void navigate('/auth/signin', { replace: true })
  }, [status, navigate])

  return (
    <main
      style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center' }}
      aria-live="polite"
    >
      <p style={{ color: 'var(--color-text-secondary)' }}>Signing you in…</p>
    </main>
  )
}
